import { render, staticRenderFns } from "./workerIdCardImg.vue?vue&type=template&id=0a60f4ab&scoped=true&"
import script from "./workerIdCardImg.vue?vue&type=script&lang=js&"
export * from "./workerIdCardImg.vue?vue&type=script&lang=js&"
import style0 from "./workerIdCardImg.vue?vue&type=style&index=0&id=0a60f4ab&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a60f4ab",
  null
  
)

export default component.exports